import { Box, Button, Stack, Typography } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import { handleErrorMessage, openSuccessNotification } from "helpers/methods";
import { deletecampaignById } from "../CampaignService";

interface CustomProps {
  isVisible: boolean;
  setVisible: Function;
  isLoading?: boolean;
  campaignId: number;
  refresh: Function;
}

const DeleteCampaignModal = (props: CustomProps) => {
  const handleCampaignDelete = async () => {
    try {
      await deletecampaignById(props.campaignId);
      openSuccessNotification("Campaign Deleted Successfully");
      props.setVisible(false);
      props.refresh();
    } catch (error: any) {
      handleErrorMessage(error);
    } finally {
    }
  };

  const handleDialogClose = () => {
    props.setVisible(false);
  };

  const getBody = () => {
    return (
      <Box mt={3}>
        <Typography
          variant="body1"
          sx={{ textAlign: "center", marginTop: "3px" }}
        >
          Are you sure you want to delete the Campaign?
        </Typography>
      </Box>
    );
  };

  const getFooter = () => {
    return (
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        p={1}
      >
        <Button
          id="delete_comment_no"
          size="small"
          variant="outlined"
          onClick={handleDialogClose}
          disabled={props.isLoading}
        >
          Cancel
        </Button>
        <Button
          id="delete_comment_yes"
          size="small"
          variant="contained"
          disabled={props.isLoading}
          onClick={handleCampaignDelete}
        >
          Delete
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={handleDialogClose}
      isDialogOpen={props.isVisible}
      body={getBody()}
      footer={getFooter()}
      title={<Typography>Delete Campaign</Typography>}
      closeButtonVisibility
      closable
      maxWidth="xs"
    />
  );
};

export default DeleteCampaignModal;
